import * as React from 'react';

function SvgEdit(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 16.59a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2a.75.75 0 01-.75-.75zM4.767 9.8L13.619.947a1 1 0 011.415 0l2.622 2.623a1 1 0 010 1.414l-8.853 8.853a1 1 0 01-.668.292l-2.727.104a1 1 0 01-1.038-1.037l.105-2.727a1 1 0 01.292-.669zm9.566-7.429l1.816 1.852-.894.91L13.421 3.3l.912-.929zm-1.962 2l1.833 1.833-6.52 6.63-1.83.014.014-1.851 6.503-6.626z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgEdit;
